export enum TenderedAmountEnum {
  OTHER = 0,
  FIVE = 5,
  TEN = 10,
  TWENTY = 20,
  FIFTY = 50,
  EXACT = 999999,
  PRE_CALCULATED = 999998
}
